/* @flow */

import type {
  CmsPage,
} from "shop-state/types";

import type { Model, EffectErrorMessage } from "crustate";
import type { Response } from "./util";
import { updateData, EFFECT_ERROR } from "crustate";

type Data =
  | { state: "INIT" }
  | { state: "LOADING" }
  | { state: "LOADED", data: CmsPage };

export type CmsPageResponse =
  Response<typeof CMS_PAGE_RESPONSE, ?CmsPage> | EffectErrorMessage;

export type CmsPageRequest = {
  tag: typeof CMS_PAGE_REQUEST,
  url: string,
};

export const CMS_PAGE_RESPONSE: "response/cms-page" = "response/cms-page";
export const CMS_PAGE_REQUEST: "request/cms-page" = "request/cms-page";

export const load = (url: string): CmsPageRequest => {
  return {
    tag: CMS_PAGE_REQUEST,
    url,
  };
};

export const CmsPageModel: Model<Data, {
  url: string}, CmsPageRequest | CmsPageResponse> = {
    id: "cms-page",
    init: ({ url }) =>
      updateData(
        { state: "LOADING" },
        load(url)
      ),
    update: (state: Data, msg) => {
      switch (msg.tag) {
        case EFFECT_ERROR:
          throw new Error("Route load failed");
        case CMS_PAGE_RESPONSE:
          if (msg.data && (state.state === "LOADING")) {
            return updateData({ state: "LOADED", data: msg.data });
          }

          break;
        default:
      }
    },
  };
